var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M8 11.334v-4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 4.667A.667.667 0 1 1 8 6a.667.667 0 0 1 0-1.333"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M1.333 8c0-3.142 0-4.713.976-5.69.977-.976 2.548-.976 5.69-.976s4.715 0 5.691.976c.976.977.976 2.548.976 5.69s0 4.715-.976 5.691-2.548.976-5.69.976-4.714 0-5.69-.976c-.977-.976-.977-2.548-.977-5.69Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d8672f74683d11b43810d60765398f2b.svg";
export { ForwardRef as ReactComponent };